export const SET_TRADE_IN_VEHICLE = 'SET_TRADE_IN_VEHICLE';
export const SET_TRADE_IN_TAX_CREDIT_DETAILS = 'SET_TRADE_IN_TAX_CREDIT_DETAILS';

export default {
    SET_TRADE_IN_VEHICLE,
    SET_TRADE_IN_TAX_CREDIT_DETAILS,
};
